import React, { useEffect, useState, useContext, useRef } from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from '../../CustomHooks/useFetch';
import useGoogleAnalytics from '../../CustomHooks/useGoogleAnalytics';
import FoodAndDrinks2_AddOrEditProduct_View from './FoodAndDrinks2_AddOrEditProduct_View';
import useOptionGroups from '../OptionGroups/useOptionGroups';



export default function FoodAndDrinks2_AddOrEditProduct(props) {
    const { selectedCategoryId, editProductId, closeForm } = props;
    const globalContext = useContext(GlobalContext);
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [description, setDesription] = useState('');
    const [price, setPrice] = useState(1.1);
    const [available, setAvailable] = useState(true);
    const [fileInfo, setFileInfo] = useState(null);
    const [addProductResponse, addProductHook] = useFetch();
    const [editPictureResponse, editPictureHook] = useFetch();
    const [getProductHookResponse, getProductHook] = useFetch();
    const [editProductHookResponse, editProductHook] = useFetch();
    const [pictureUrl, setPictureUrl] = useState(null);
    const setGAPath = useGoogleAnalytics();

    const [optionGroups, setOptionGroups] = useState([]);
    const [optionGroupSelectValue, setOptionGroupSelectValue] = useState(2);
    const [optionGroupId, setOptionGroupId] = useState(-1);//-1 ise kapali, 0 ise yeni urun, >0 ise edit ve urun id
    const [getOptionGroupsHookResponse, getOptionGroupsHook] = useOptionGroups();
    const [productGroup, setProductGroup] = useState('');

    useEffect(
        () => {
            if (optionGroupId == -1) {
                console.log('option group edit oldu veya yeni bir option group eklendi')
                getOptionGroupsHook();
            }
        }, [optionGroupId]
    )

    useEffect(
        () => {
            //option grup edit oldugunda ismi degismis olabilir.
            console.log('getOptionGroupsHookResponse');
            setOptionGroups(
                optionGroups.map(
                    optionGroupAdded => {
                        let renamedOptionGroup = getOptionGroupsHookResponse.foodOptionGroups.filter(o => o.id == optionGroupAdded.id)[0];
                        return { id: renamedOptionGroup.id, name: renamedOptionGroup.optionGroupName }
                    }
                )
            )
        }, [getOptionGroupsHookResponse]
    )

    const addToOptionGroups = () => {

        if (getOptionGroupsHookResponse.foodOptionGroups.length > 0) {
            let foodOptionGroupsOnState = [...getOptionGroupsHookResponse.foodOptionGroups];
            let optionGroupName = getOptionGroupsHookResponse.foodOptionGroups.filter(optionGroup => optionGroup.id == optionGroupSelectValue)[0].optionGroupName;
            let newOptionGroup = { id: optionGroupSelectValue, name: optionGroupName };


            let newOptionGroups = [...optionGroups];
            newOptionGroups.push(newOptionGroup);
            setOptionGroups(newOptionGroups);
        }
    }

    function removeFromOptionGroups(optionGroupId) {
        let newOptionGroups = optionGroups.filter(optionGroup => optionGroup.id != optionGroupId);
        setOptionGroups(newOptionGroups);
    }

    useEffect(
        () => {
            setGAPath('/AddOrEditProduct');
        }, []
    )



    const setSelectedFileToImageSrc = (file) => {
        if (file == null) {
            setPictureUrl(null);
        }
        else {
            var fr = new FileReader();
            fr.onload = function () {
                setPictureUrl(fr.result);
            }
            fr.readAsDataURL(file);
        }


    }

    const validate = () => {
        if (name == '') {
            setNameError('Enter a food or drink name');
            return false;
        }
        return true;

    }
    const submit = () => {
        if (!validate()) {
            return;
        }
        if (editProductId == 0) {
            //urun ekleme imis
            addProduct();
        }
        else {
            //editmis
            editProduct();
        }
    }

    const addProduct = () => {
        addProductHook(
            {
                url: '/admin/products',
                method: 'POST',
                addTokenHeader: true,
                postData: {
                    title: name,
                    type: "Food",
                    description: description,
                    isAvailable: available,
                    price: price,
                    categoryId: selectedCategoryId,
                    optionGroupIdList: optionGroups.map(optionGroup => optionGroup.id),
                    productGroup: productGroup,
                },
            }
        )
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });
    }

    useEffect(
        () => {
            if (addProductResponse.length != 0 && addProductResponse) {
                if (fileInfo != null) {
                    console.log(fileInfo);
                    let formData = new FormData();
                    formData.append('file', fileInfo);
                    editPictureHook(
                        {
                            url: '/admin/products/' + addProductResponse.id + '/upload-image',
                            method: 'PUT',
                            postData: formData,
                            addTokenHeader: true,
                            multipart: true,
                        }
                    )
                }
                else {
                    props.closeForm();
                }
            }
        }
        , [addProductResponse]
    )


    const editProduct = async (newData, oldData) => {
        editProductHook(
            {
                url: '/admin/products/' + editProductId,
                method: 'PUT',
                postData: {
                    title: name,
                    description: description,
                    isAvailable: available,
                    price: price,
                    categoryId: selectedCategoryId,
                    optionGroupIdList: optionGroups.map(optionGroup => optionGroup.id),
                    productGroup: productGroup,
                },
                addTokenHeader: true,
            }
        )

        if (fileInfo != null) {
            console.log(fileInfo);
            let formData = new FormData();
            formData.append('file', fileInfo);
            editPictureHook(
                {
                    url: '/admin/products/' + editProductId + '/upload-image',
                    method: 'PUT',
                    postData: formData,
                    addTokenHeader: true,
                    multipart: true,
                }
            )
        }
        else {

            if (pictureUrl == null) {
                editPictureHook(
                    {
                        url: '/admin/products/' + editProductId + '/remove-image',
                        method: 'PUT',
                        addTokenHeader: true,
                        multipart: true,
                    }
                )
            }
        }

        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '...', showButton: false } });

    }

    useEffect(
        () => {
            if (editProductHookResponse.id != null) {
                props.closeForm();
            }
        }, [editProductHookResponse]
    )

    useEffect(
        () => {
            if (editPictureResponse.success != null) {
                props.closeForm();
            }
        }, [editPictureResponse]
    )

    useEffect(
        () => {
            if (editProductId > 0) {
                //edit edilecek urun
                getProductHook(
                    {
                        url: '/admin/products/' + editProductId,
                        method: 'GET',
                        postData: null,
                        addTokenHeader: true,
                    }
                )
            }
        }, []
    )


    useEffect(
        () => {
            if (getProductHookResponse.id != null) {
                const { title, description, price, isAvailable, picture, productGroup } = getProductHookResponse;
                setName(title);
                setDesription(description);
                setPrice(price);
                setAvailable(isAvailable);
                setPictureUrl(picture == '' ? null : 'https://' + picture);
                setOptionGroups(
                    getProductHookResponse.optionGroups.map(
                        optionGroup => { return { id: optionGroup.id, name: optionGroup.optionGroupName } }
                    )
                )
                setProductGroup(productGroup);
            }
        }, [getProductHookResponse]
    )

    /*
    useEffect(
        () => {
            getOptionGroups();
        }, [getProductHookResponse]
    )


    const getOptionGroups = () => {
        getOptionGroupsHook(
            {
                url: '/admin/food-options/',
                method: 'GET',
                postData: null,
                addTokenHeader: true,
            }
        )
    }
    */

    useEffect(
        () => {
            //option grup edit oldugunda ismi degismis olabilir.
            console.log('getOptionGroupsHookResponse');
            console.log(getOptionGroupsHookResponse);
            if (!Array.isArray(getOptionGroupsHookResponse)) { //response dolunca object oluyor
                console.log('not arr');

                setOptionGroups(
                    optionGroups.map(
                        optionGroupAdded => {
                            let renamedOptionGroup = getOptionGroupsHookResponse.foodOptionGroups.filter(o => o.id == optionGroupAdded.id)[0];

                            console.log(renamedOptionGroup.id);
                            return { id: renamedOptionGroup.id, name: renamedOptionGroup.optionGroupName }
                        }
                    )
                )

            }
        }, [getOptionGroupsHookResponse]
    )

    useEffect(
        () => {
            //option grup edit oldugunda ismi degismis olabilir.
            console.log('getOptionGroupsHookResponse2');
            console.log(getOptionGroupsHookResponse);
            let selectedOptionGroupId = 0;
            if (!Array.isArray(getOptionGroupsHookResponse)) { //response dolunca object oluyor
                console.log('not arr2');
                getOptionGroupsHookResponse.foodOptionGroups.map(
                    optionGroup =>
                        selectedOptionGroupId = optionGroup.id
                )
                console.log('2:' + selectedOptionGroupId);
                setOptionGroupSelectValue(selectedOptionGroupId);
            }
        }, [getOptionGroupsHookResponse]
    )

    const setSelectedOptionGroupIdAndCloseOptionGroupForm = (newlyAddedOptionGroupId) => {
        console.log('form kapandi');
        setOptionGroupId(-1); //bu option group formunu kapatiyor
        setOptionGroupSelectValue(newlyAddedOptionGroupId);
    }


    return (
        <FoodAndDrinks2_AddOrEditProduct_View
            setSelectedFileToImageSrc={setSelectedFileToImageSrc}
            setFileInfo={setFileInfo}
            fileInfo={fileInfo}
            closeForm={closeForm}
            submit={submit}
            getOptionGroupsHookResponse={getOptionGroupsHookResponse}
            optionGroups={optionGroups}
            addToOptionGroups={addToOptionGroups}
            removeFromOptionGroups={removeFromOptionGroups}
            optionGroupSelectValue={optionGroupSelectValue}
            setOptionGroupSelectValue={setOptionGroupSelectValue}
            description={description}
            setDesription={setDesription}
            price={price}
            setPrice={setPrice}
            available={available}
            setAvailable={setAvailable}
            pictureUrl={pictureUrl}
            setPictureUrl={setPictureUrl}
            optionGroupId={optionGroupId}
            setOptionGroupId={setOptionGroupId}
            name={name}
            setName={setName}
            nameError={nameError}
            setSelectedOptionGroupIdAndCloseOptionGroupForm={setSelectedOptionGroupIdAndCloseOptionGroupForm}
            productGroup={productGroup}
            setProductGroup={setProductGroup}
        />
    )
}
